var map = {
	"./1.gif": 6197,
	"./10.gif": 2362,
	"./11.gif": 4559,
	"./12.gif": 5691,
	"./13.gif": 7177,
	"./14.gif": 9230,
	"./15.gif": 2701,
	"./16.gif": 2568,
	"./17.gif": 7169,
	"./18.gif": 1815,
	"./19.gif": 6649,
	"./2.gif": 1508,
	"./20.gif": 1716,
	"./21.gif": 8996,
	"./22.gif": 1953,
	"./23.gif": 5989,
	"./24.gif": 6460,
	"./25.gif": 9233,
	"./3.gif": 3934,
	"./4.gif": 1276,
	"./5.gif": 1389,
	"./6.gif": 3161,
	"./7.gif": 4720,
	"./8.gif": 3374,
	"./9.gif": 4280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5212;